import { useMutation } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function usePropertyFloorCreateMultiple() {
  const axiosPrivate = useAxiosPrivate();
  return useMutation({
    mutationFn: (data) => {
      return axiosPrivate({
        method: "POST",
        url: "PropertyFloor/Multiple",
        data,
      });
    },
  });
}

export default usePropertyFloorCreateMultiple;
